import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { QuizPlayerQuestionContentFragmentDoc, QuizPlayerMtfComponentFragmentDoc, QuizPlayerFtbComponentFragmentDoc, QuizPlayerImageHotspotComponentFragmentDoc } from './QuizPlayerQuestionContent';
import { EntityMediaFragmentDoc } from '../../../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import { FeedbackQuestionsFragmentDoc, FeedbackQuestionFragmentDoc } from '../../../../../../../../../features/feedback/graphql/fragments/generated/FeedbackQuestions';
export type QuizPlayerContentFragment = { id: string, name: string, duration: number, maxScore: number, passingPercentage?: number | null, versionStatus?: Types.ResourceStatusEnum | null, languageType?: Types.LanguageEnum | null, isLocalizedContent: boolean, quizQuestionsConfig: { questionCount: number, questions: Array<{ id: string, questionText?: string | null, questionType: Types.QuestionTypeEnum, subType?: Types.QuestionSubTypeEnum | null, correctAnswerFeedback?: string | null, incorrectAnswerFeedback?: string | null, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null, options?: Array<{ optionId: string, optionText: string, optionRelativeScore?: number | null, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }> | null, mtfComponent?: { leftElements: Array<{ text: string, id: string, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }>, distractedRightElements?: Array<{ text: string, id: string, attachments?: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> | null }> | null } | null, ftbComponents: Array<{ text?: string | null, isBlank: boolean, id: string, distractors?: Array<{ text: string }> | null }>, imageHotspotComponents: Array<{ text?: string | null, id: string, x: number, y: number, distractors?: Array<{ text: string }> | null }>, globalDistractedOptions: Array<{ id: string, text: string }>, associations: Array<{ entityAssociation: { lessonId: string, lessonPageId?: string | null } }> }>, quizQuestions: Array<{ questionId: string, sectionId?: string | null, order: number }> }, instruction?: { text?: string | null, medias: Array<{ name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null }> } | null, feedbackQuestions?: Array<{ id: string, type: Types.FeedbackQuestionTypeEnum, questions: Array<{ id: string, description?: string | null, questionText?: string | null, questionType: Types.QuestionTypeEnum, settings?: { ratingScale?: number | null } | null }> }> | null, quizSections?: Array<{ _id: string, name: string, order: number }> | null, settings?: { revealAnswers?: Types.QuizRevealAnswerEnum | null, timeLimit?: number | null, timeLimitApplicableOn?: Types.TimeLimitApplicableOnEnum | null, retakeAllowedCount?: number | null } | null, languageConfigs?: Array<{ contentId: string, languageType: Types.LanguageEnum, jobStatus?: Types.JobEntityStatusEnum | null }> | null };


export type QuizPlayerContentFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const QuizPlayerContentFragmentDoc = /*#__PURE__*/ gql`
    fragment QuizPlayerContent on QuizContentType {
  id
  name
  duration
  maxScore
  passingPercentage
  versionStatus
  quizQuestionsConfig(attemptId: $attemptId) {
    questionCount
    questions {
      ...QuizPlayerQuestionContent
    }
    quizQuestions {
      questionId
      sectionId
      order
    }
  }
  instruction {
    text
    medias {
      ...EntityMedia
    }
  }
  feedbackQuestions {
    ...FeedbackQuestions
  }
  quizSections {
    _id
    name
    order
  }
  settings {
    revealAnswers
    timeLimit
    timeLimitApplicableOn
    retakeAllowedCount
  }
  languageConfigs {
    contentId
    languageType
    jobStatus
  }
  languageType
  isLocalizedContent
}
    `;